
import { Component, Vue } from 'vue-property-decorator';

import { getBCEIDUrl } from "@/components/utils/utils";

@Component
export default class LandingPage extends Vue { 
    
    
  
    public navigate(userType) {
            
        if (userType === "new") {
              //Register a BCeID
              window.location.replace(getBCEIDUrl());
        } else if (userType === "returning") {
              //Login BCeID
              this.$router.push({ name: "surveys" });
        }  
    }  
  
};
